import { useContext } from "react";
import { DrawerContextSetter, DrawerContextState } from "../context/darwer";

export const useDrawerState = () => useContext(DrawerContextState);
export const useDrawerSetter = () => useContext(DrawerContextSetter);
